var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"cb-button-text",attrs:{"color":_vm.color,"disabled":_vm.disabled,"title":_vm.text,"outlined":"","primary":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }